import React from 'react';
import {
  Dropdown,
  DropdownMenu,
  Icon,
  List,
  Transition
} from 'semantic-ui-react';

import NavigationDropdownListItem from './NavigationDropdownListItem';
import { useNavigation } from './NavigationContext';
import type { NavigationItem } from './types';

interface NavigationDropdownProps {
  item: NavigationItem;
}

const NavigationDropdown = ({ item }: NavigationDropdownProps) => {
  const { openDropdown, setOpenDropdown } = useNavigation();
  const isOpen = openDropdown === item.url;

  return (
    <Dropdown
      open={isOpen}
      onOpen={() => !isOpen && setOpenDropdown(item.url)}
      onClose={() => isOpen && setOpenDropdown(null)}
      trigger={
        <Icon
          name={isOpen ? 'caret up' : 'caret down'}
          className='caret-button'
        />
      }
    >
      <Transition visible={isOpen} animation='scale' duration={200}>
        <DropdownMenu onClick={(e: React.MouseEvent) => e.stopPropagation()}>
          <List className='nav-list'>
            {item.items.map((child) => (
              <NavigationDropdownListItem key={child.url} item={child} />
            ))}
          </List>
        </DropdownMenu>
      </Transition>
    </Dropdown>
  );
};

export default NavigationDropdown;